//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import menuList from '~/config/navigationPaymentSystemsAndCurrencies';

export default {
  data() {
    return {
      menuList,
    };
  },

  methods: {
    isCurrentRoute(name) {
      const currentRouteName = this.$route.name;
      return (name === currentRouteName);
    },
  },
};
